// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const drizzile: PokeData = {
  "id": 817,
  "name": "drizzile",
  "height": 7,
  "weight": 115,
  "base_experience": 147,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "pound",
    "bind",
    "growl",
    "water-gun",
    "rain-dance",
    "water-pulse",
    "u-turn",
    "sucker-punch",
    "soak",
    "liquidation",
    "tearful-look"
  ],
  "moves": [
    "growl",
    "rain-dance",
    "liquidation",
    "bubble",
    "aqua-jet",
    "bubble-beam",
    "water-spout",
    "whirlpool",
    "aqua-tail",
    "hydro-pump",
    "life-dew",
    "brine",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 432,
    "item": null,
    "species": [
      {
        "name": "sobble",
        "order": 816,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "drizzile",
        "order": 817,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 816,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "inteleon",
        "order": 818,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 817,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 90,
    "ability_power": 95
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
